module.exports = __webpack_public_path__ + "static/media/21.f93a9e2f.mp3";